import { render, staticRenderFns } from "./confirmer.vue?vue&type=template&id=b4faef08"
import script from "./confirmer.vue?vue&type=script&lang=js"
export * from "./confirmer.vue?vue&type=script&lang=js"
import style0 from "./confirmer.vue?vue&type=style&index=0&id=b4faef08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports